module.exports = __webpack_public_path__ + "dc61b454e2510b0caa2e987ac3de5008.svg";